import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";

import store from "./store";
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import MsalConfig from './config/azureSSO';

const pca = new PublicClientApplication(MsalConfig);

ReactDOM.render(
  <Provider store={store}>
    <MsalProvider instance={pca}>
      <App />
    </MsalProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
